/** Pixel Sidekicks — Polski + English */
export const SUPPORTED = [
  { code: 'pl', label: 'Polski', flag: 'PL' },
  { code: 'en', label: 'English', flag: 'GB' },
];

export const strings = {
  pl: {
    brand: 'Pixel Sidekicks',
    brandDomain: 'pixelsidekicks.com',
    nav: {
      home: 'Start',
      sidekicks: 'AI Sidekicki',
      flow: 'Jak to działa',
      why: 'Dlaczego my',
      faq: 'FAQ',
      contact: 'Kontakt',
    },
    headerCta: 'Czatuj z AI',
    hero: {
      title: 'Zapytaj AI sidekicka. Dostaniesz odpowiedź, nie ścianę opcji.',
      lead:
        'Twój osobisty model AI w przeglądarce: promptujesz, on myśli, Ty lecisz dalej. Pisz, planuj, burz mózg — jak z czatem, tylko z misją.',
      ctaPrimary: 'Uruchom AI',
      ctaSecondary: 'Poznaj sidekicki',
      legal:
        'Płatna subskrypcja tygodniowa. Płatność przez Mobile Billing (rachunek telefoniczny). Akceptując, zgadzasz się z Regulaminem. Anulowanie w dowolnym momencie. Support: support@pixelsidekicks.com. Dostawca: Niffo Mobile B.V.',
      imageAlt: 'AI sidekick Pixel Sidekicks',
    },
    proof: {
      items: [
        { value: 'AI chat', label: 'Prompt → odpowiedź' },
        { value: '< 1 min', label: 'Do pierwszego outputu' },
        { value: '24/7', label: 'Model zawsze online' },
        { value: '0 app', label: 'Czysto w przeglądarce' },
      ],
    },
    sidekicks: {
      kicker: 'Twoje AI persony',
      title: 'Cztery sidekicki.',
      titleAccent: 'Cztery mózgi do zadań.',
      body: 'Każdy AI sidekick trenowany pod jedną robotę. Wybierasz personę, wrzucasz prompt — reszta dzieje się w czacie.',
      items: [
        {
          num: '01',
          title: 'Pisarz AI',
          prompt: '„Napisz mail w moim tonie…”',
          description: 'Szkice, maile i posty. Promptujesz kontekst — model oddaje gotowy tekst.',
          image: '/images/sidekicks/Interview-Coach.png',
        },
        {
          num: '02',
          title: 'Strateg AI',
          prompt: '„Ułóż mi plan na dziś…”',
          description: 'Priorytety, listy i kolejne kroki, gdy Twój mózg ma za dużo tabów otwartych.',
          image: '/images/sidekicks/Lebens-Stratege.png',
        },
        {
          num: '03',
          title: 'Kreatywny AI',
          prompt: '„Daj 5 świeżych wariantów…”',
          description: 'Burza mózgów na żądanie. Gdy utkniesz, sidekick generuje nowe kąty.',
          image: '/images/sidekicks/Wellness-Begleiter.png',
        },
        {
          num: '04',
          title: 'Tutor AI',
          prompt: '„Wyjaśnij to prościej…”',
          description: 'Tłumaczy, ćwiczy i porządkuje wiedzę — jak prywatny coach w czacie 24/7.',
          image: '/images/sidekicks/Sprachtutor.png',
        },
      ],
    },
    flow: {
      kicker: 'Od zera do promptu',
      title: 'Wejdź.',
      titleAccent: 'Zapytaj. Działaj.',
      intro: 'Bez instalacji modelu. Otwierasz przeglądarkę i od razu rozmawiasz z AI.',
      steps: [
        {
          num: '1',
          title: 'Załóż konto',
          description: 'E-mail i hasło. Sesja AI startuje w mniej niż minutę.',
        },
        {
          num: '2',
          title: 'Wybierz AI sidekicka',
          description: 'Personę pod zadanie: pisanie, plan, pomysły albo nauka.',
        },
        {
          num: '3',
          title: 'Wrzuć pierwszy prompt',
          description: 'Pisz naturalnie. Model odpowiada, Ty iterujesz i zapisujesz wynik.',
        },
      ],
    },
    why: {
      kicker: 'Dlaczego ten AI',
      title: 'Mniej dashboardu.',
      titleAccent: 'Więcej rozmowy.',
      body: 'Pixel Sidekicks nie każe Ci klikać przez 40 ekranów. To AI sidekicki, z którymi gadasz jak z czatem — tylko każdy ma swoją specjalizację.',
      points: [
        'Odpowiedzi w stylu rozmowy, nie ściany ustawień',
        'Persony AI dopasowane do konkretnych zadań',
        'Twój prompt history zostaje pod ręką w przeglądarce',
      ],
      cta: 'Zacznij czat z AI',
      imageAlt: 'AI sidekick Strateg',
    },
    cta: {
      title: 'Twój AI sidekick czeka na pierwszy prompt.',
      body: 'Odblokuj pełny dostęp do Pixel Sidekicks — modele AI, persony i workflow w jednej zakładce przeglądarki.',
      button: 'Uruchom AI',
      priceLine: 'Subskrypcja tygodniowa · płatność Mobile Billing',
      helpLine: 'Support: support@pixelsidekicks.com',
      legalBox:
        'Pixel Sidekicks to płatna usługa AI. Zawierając subskrypcję, akceptujesz Regulamin. Subskrypcja odnawia się automatycznie, dopóki nie zostanie anulowana. Płatność przez Mobile Billing. Dostawca: Niffo Mobile B.V., Stationsplein 28, 1382 AD Weesp, Holandia.',
    },
    faq: {
      kicker: 'Pytania o AI',
      title: 'Szybki FAQ modelu.',
      intro: 'Najczęstsze pytania o Pixel Sidekicks i AI sidekicki.',
      items: [
        {
          q: 'Czym jest Pixel Sidekicks?',
          a: 'Przeglądarkowa usługa AI z personami-sidekickami. Promptujesz w czacie — dostajesz teksty, plany, pomysły i wyjaśnienia.',
        },
        {
          q: 'Jak zacząć rozmowę z AI?',
          a: 'Kliknij „Uruchom AI”, załóż konto i od razu wrzuć pierwszy prompt do wybranego sidekicka.',
        },
        {
          q: 'Ile to kosztuje?',
          a: 'Pixel Sidekicks działa w modelu subskrypcji tygodniowej. Płatność przez Mobile Billing (rachunek telefoniczny).',
        },
        {
          q: 'Czy mogę anulować w dowolnym momencie?',
          a: 'Tak. Anulowanie obowiązuje od końca bieżącego okresu rozliczeniowego.',
        },
        {
          q: 'Na jakich urządzeniach działa AI?',
          a: 'Na nowoczesnych przeglądarkach (Chrome, Safari, Firefox, Edge) oraz na smartfonach i tabletach.',
        },
        {
          q: 'Czy potrzebuję aplikacji albo lokalnego modelu?',
          a: 'Nie. Cały AI działa w chmurze w przeglądarce — bez pobierania i instalacji.',
        },
      ],
      contactTitle: 'Model nie ogarnął Twojego pytania?',
      contactLead: 'Napisz do supportu — odpowiadamy szybko.',
      email: 'support@pixelsidekicks.com',
    },
    footer: {
      blurb:
        'Pixel Sidekicks — AI sidekicki do czatu, pisania i planowania w przeglądarce. Dostawca: Niffo Mobile B.V.',
      legalShort:
        'Płatna subskrypcja tygodniowa. Anulowanie w dowolnym momencie. Szczegóły rozliczeń i odstąpienia w Regulaminie.',
      navTitle: 'Nawigacja',
      contactTitle: 'Kontakt',
      cta: 'Czatuj z AI',
      copyright: 'Pixel Sidekicks. Niffo Mobile B.V. Wszelkie prawa zastrzeżone.',
      agb: 'Regulamin',
      privacy: 'Prywatność',
      help: 'Pomoc',
      imprint: 'Nota prawna',
      widerruf: 'Odstąpienie',
    },
  },
  en: {
    brand: 'Pixel Sidekicks',
    brandDomain: 'pixelsidekicks.com',
    nav: {
      home: 'Home',
      sidekicks: 'AI Sidekicks',
      flow: 'How it works',
      why: 'Why us',
      faq: 'FAQ',
      contact: 'Contact',
    },
    headerCta: 'Chat with AI',
    hero: {
      title: 'Ask your AI sidekick. Get an answer, not a settings maze.',
      lead:
        'Your personal AI in the browser: you prompt, it thinks, you move on. Write, plan, brainstorm — chat energy, with a job to do.',
      ctaPrimary: 'Launch AI',
      ctaSecondary: 'Meet the sidekicks',
      legal:
        'Paid weekly subscription. Payment via mobile billing. By continuing you accept our Terms. Cancel anytime. Support: support@pixelsidekicks.com. Provider: Niffo Mobile B.V.',
      imageAlt: 'Pixel Sidekicks AI sidekick',
    },
    proof: {
      items: [
        { value: 'AI chat', label: 'Prompt → reply' },
        { value: '< 1 min', label: 'To first output' },
        { value: '24/7', label: 'Model always on' },
        { value: '0 apps', label: 'Browser-only AI' },
      ],
    },
    sidekicks: {
      kicker: 'Your AI personas',
      title: 'Four sidekicks.',
      titleAccent: 'Four brains on call.',
      body: 'Each AI sidekick is tuned for one job. Pick a persona, drop a prompt — the rest happens in chat.',
      items: [
        {
          num: '01',
          title: 'Writer AI',
          prompt: '“Rewrite this in my tone…”',
          description: 'Drafts, emails, and posts. You prompt the context — the model ships the copy.',
          image: '/images/sidekicks/Interview-Coach.png',
        },
        {
          num: '02',
          title: 'Strategist AI',
          prompt: '“Build my plan for today…”',
          description: 'Priorities, lists, and next steps when your brain has too many tabs open.',
          image: '/images/sidekicks/Lebens-Stratege.png',
        },
        {
          num: '03',
          title: 'Creative AI',
          prompt: '“Give me 5 fresh angles…”',
          description: 'Brainstorm on demand. When you stall, the sidekick generates new takes.',
          image: '/images/sidekicks/Wellness-Begleiter.png',
        },
        {
          num: '04',
          title: 'Tutor AI',
          prompt: '“Explain this more simply…”',
          description: 'Explains, drills, and organises knowledge — a private coach in chat, 24/7.',
          image: '/images/sidekicks/Sprachtutor.png',
        },
      ],
    },
    flow: {
      kicker: 'From zero to prompt',
      title: 'Open.',
      titleAccent: 'Ask. Ship.',
      intro: 'No model install. Open the browser and talk to AI right away.',
      steps: [
        {
          num: '1',
          title: 'Create an account',
          description: 'Email and password. Your AI session starts in under a minute.',
        },
        {
          num: '2',
          title: 'Pick an AI sidekick',
          description: 'A persona for the job: writing, planning, ideas, or learning.',
        },
        {
          num: '3',
          title: 'Drop your first prompt',
          description: 'Write naturally. The model replies, you iterate, you save the output.',
        },
      ],
    },
    why: {
      kicker: 'Why this AI',
      title: 'Less dashboard.',
      titleAccent: 'More dialogue.',
      body: 'Pixel Sidekicks will not make you click through forty screens. These are AI sidekicks you talk to like a chat — each with a specialty.',
      points: [
        'Conversation-style answers, not a wall of settings',
        'AI personas tuned to concrete jobs',
        'Your prompt history stays handy in the browser',
      ],
      cta: 'Start chatting with AI',
      imageAlt: 'Strategist AI sidekick',
    },
    cta: {
      title: 'Your AI sidekick is waiting on the first prompt.',
      body: 'Unlock full access to Pixel Sidekicks — AI models, personas, and workflows in one browser tab.',
      button: 'Launch AI',
      priceLine: 'Weekly subscription · paid via mobile billing',
      helpLine: 'Support: support@pixelsidekicks.com',
      legalBox:
        'Pixel Sidekicks is a paid AI service. By subscribing you accept our Terms. The subscription renews automatically unless cancelled. Payment via mobile billing. Provider: Niffo Mobile B.V., Stationsplein 28, 1382 AD Weesp, Netherlands.',
    },
    faq: {
      kicker: 'AI questions',
      title: 'Quick model FAQ.',
      intro: 'The most common questions about Pixel Sidekicks and the AI sidekicks.',
      items: [
        {
          q: 'What is Pixel Sidekicks?',
          a: 'A browser AI service with persona sidekicks. You prompt in chat — you get copy, plans, ideas, and explanations.',
        },
        {
          q: 'How do I start talking to the AI?',
          a: 'Click “Launch AI”, create an account, and drop your first prompt to a sidekick.',
        },
        {
          q: 'What does it cost?',
          a: 'Pixel Sidekicks is offered as a weekly subscription. Payment is via mobile billing.',
        },
        {
          q: 'Can I cancel anytime?',
          a: 'Yes. Cancellation takes effect at the end of the current billing period.',
        },
        {
          q: 'Which devices run the AI?',
          a: 'Modern browsers including Chrome, Safari, Firefox, and Edge, plus phones and tablets.',
        },
        {
          q: 'Do I need an app or a local model?',
          a: 'No. The AI runs in the cloud inside your browser — no download or install.',
        },
      ],
      contactTitle: 'Model miss your question?',
      contactLead: 'Ping support — we reply quickly.',
      email: 'support@pixelsidekicks.com',
    },
    footer: {
      blurb:
        'Pixel Sidekicks — AI sidekicks for chat, writing, and planning in the browser. Provider: Niffo Mobile B.V.',
      legalShort:
        'Paid weekly subscription. Cancel anytime. See Terms for billing and withdrawal details.',
      navTitle: 'Navigate',
      contactTitle: 'Contact',
      cta: 'Chat with AI',
      copyright: 'Pixel Sidekicks. Niffo Mobile B.V. All rights reserved.',
      agb: 'Terms',
      privacy: 'Privacy',
      help: 'Help',
      imprint: 'Imprint',
      widerruf: 'Withdrawal',
    },
  },
};
